import { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import config from "../../config";
import Barcode from "../outlet/outletTabs";
import SideMenu from "./sideMenu";
import CustomTabs from "../tabs";
import ShopProfile from "../settings/shopProfile";
import InvoiceCustomization from "../settings/invoiceCustomization";
import Outlet from "../settings/outlet";
import { useAccess } from "../../provider/AccessProvider";
import { SETTINGSACCESS } from "../../utils/constant";
import { Alert } from "antd";

const Settings = (props) => {
  const [activeTabs, setActiveTab] = useState("1");
  const shopDetails = useSelector((state) => state.shopDetails);
  const access = useAccess(SETTINGSACCESS);
  const tabs = useMemo(() => {
    const items = [
      {
        key: "1",
        label: `Profile`,
      },
      {
        key: "2",
        label: `Outlet`,
      },
      {
        key: "3",
        label: `Invoice Customization`,
      },
      {
        key: "4",
        label: `Barcode Printer`,
      },
    ];
    if (shopDetails.shopType === "Restaurant") {
      items.splice(2, 1);
    }
    if (shopDetails.userType !== "Shop") {
      items.splice(1, 1);
    }
    return items;
  }, [shopDetails.shopType, shopDetails.userType]);

  return (
    <>
      <CustomTabs
        items={tabs}
        activeKey={activeTabs}
        onTabChange={(v) => setActiveTab(v)}
      />
      {activeTabs === "1" && (
        <>
          {!access.viewProfile(false) ? (
            <Alert
              style={{
                padding: "20px",
                textAlign: "center",
              }}
              message="You don't have access, Please contact your administrator to request the appropriate access."
              type="error"
            />
          ) : (
            <ShopProfile />
          )}
        </>
      )}
      {activeTabs === "2" && <Outlet />}
      {activeTabs === "3" && (
        <>
          {!access.invoiceCustomization(false) ? (
            <Alert
              style={{
                padding: "20px",
                textAlign: "center",
              }}
              message="You don't have access, Please contact your administrator to request the appropriate access."
              type="error"
            />
          ) : (
            <InvoiceCustomization />
          )}
        </>
      )}
      {activeTabs === "4" && (
        <>
          {!access.barcodePrinter(false) ? (
            <Alert
              style={{
                padding: "20px",
                textAlign: "center",
              }}
              message="You don't have access, Please contact your administrator to request the appropriate access."
              type="error"
            />
          ) : (
            <Barcode />
          )}
        </>
      )}
    </>
  );
};
export default withRouter(Settings);
